export function carregarImagemComFallback(
  url: string,
  fallback: string,
  callback: (src: string) => void
) {
  const img = new Image();
  img.onload = () => callback(url);
  img.onerror = () => callback(fallback);
  img.src = url;
}
